import { render } from "./CardDetailComponent.vue?vue&type=template&id=88a0de50&scoped=true"
import script from "./CardDetailComponent.vue?vue&type=script&lang=js"
export * from "./CardDetailComponent.vue?vue&type=script&lang=js"

import "./CardDetailComponent.vue?vue&type=style&index=0&id=88a0de50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88a0de50"]])

export default __exports__